import { useConfig } from '@Src/providers/ConfigProvider';
import { styled } from '@mui/material/styles';
import Cookies from 'js-cookie';
import { MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from '@Src/providers/TranslationProvider';

const StyledSelect = styled(Select)`
  background-color: ${({ theme }) => theme.palette.common.white};
  & .MuiSelect-select {
    padding-top: ${({ theme }) => theme.spacing(1.5)};
    padding-bottom: ${({ theme }) => theme.spacing(1.5)};
  }
`;
const LanguageSelector = (): JSX.Element => {
  const {
    appId,
    isCustomDomain,
    language,
    supportedLanguages = [],
  } = useConfig();
  const { translate } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState<string>(language);

  const handleLanguageChange = (e: SelectChangeEvent<unknown>): void => {
    const value = e.target.value as string;
    let cookiePath = '/';
    // Need to set cookie path with appId in case of panacea URLs
    if (!isCustomDomain) {
      cookiePath = `/${appId}`;
    }
    const sixMonthsDate = new Date();
    sixMonthsDate.setMonth(sixMonthsDate.getMonth() + 6); // Expires in 6 months
    Cookies?.set('flipdish-customer-language', value, {
      expires: sixMonthsDate,
      path: cookiePath,
    });
    setCurrentLanguage(value);
    // Reload in next tick.
    setTimeout(() => {
      window.location.reload();
    }, 1);
  };

  return (
    <StyledSelect
      id="languageSelector"
      aria-label={translate('Select_language_from_dropdown_menu')}
      onChange={handleLanguageChange}
      value={currentLanguage}
    >
      {supportedLanguages?.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          {option.id}
        </MenuItem>
      ))}
    </StyledSelect>
  );
};

export default LanguageSelector;
